import { useFormik } from "formik";
import ModalComponent from "..";
import { useEditEventMutation } from "../../../redux/features/event/event.api";
import { CreatedEvent } from "../../../redux/features/event/event.types";
import { createEventFromExisting } from "../../../utils/helpers";
import { ModalCompProps } from "../../../utils/types";
import { Button } from "../../buttons/button";
import { EventVisibilityToggle } from "../../event/eventVisibility";

export const EventVisibilityModal = ({
  open,
  handleClose,
  event,
  onSuccess,
}: ModalCompProps & {
  event: CreatedEvent;
  onSuccess: () => void;
}) => {
  const [editEvent, { isLoading }] = useEditEventMutation();

  const { values, handleSubmit, setFieldValue, resetForm } = useFormik({
    initialValues: {
      visibility: event.visibility,
    },
    onSubmit: async (vals) => {
      const resp = await editEvent({
        id: event._id,
        payload: {
          ...createEventFromExisting(event),
          visibility: vals.visibility,
        },
      });

      if (resp?.data?.status === "success") {
        onSuccess();
        resetForm();
      }
    },
  });

  const onClose = () => {
    handleClose();
    resetForm();
  };

  return (
    <ModalComponent
      open={open}
      handleClose={onClose}
      className=""
      dialogClassName=""
      closeOnOverlayClick
      showHeader
      title={"Event Visibility"}
      subtitle={undefined}
      showBackIcon={false}
      mobileAnchorBottom
      showCloseIcon
      closeButtonClassName="!bg-white !p-0"
    >
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <EventVisibilityToggle
          visibility={values.visibility}
          onChange={(selected) => {
            setFieldValue("visibility", selected);
          }}
          showHeader={false}
          containerClassName="!gap-3"
          className="!gap-5 !bg-grey-50 !p-3"
        />

        <div className="flex w-full items-center justify-end gap-2">
          <Button
            text={"Cancel"}
            type="button"
            onClick={() => {
              onClose();
            }}
            variation="plain-grey"
            className="max-w-fit"
          />
          <Button
            text={"Save Changes"}
            type="submit"
            onClick={() => {}}
            className="max-w-fit"
            loading={isLoading}
            disabled={isLoading}
            variation={"primary"}
          />
        </div>
      </form>
    </ModalComponent>
  );
};
